import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Iteration } from '../../models/iteration';
import { MatTable } from '@angular/material/table';
import { RouteChildrenEmitterService } from '../../services/route-children-emitter/route-children-emitter.service';

@Component({
  selector: 'app-route-children-table',
  templateUrl: './route-children-table.component.html',
  styleUrls: ['./route-children-table.component.css']
})
export class RouteChildrenTableComponent implements OnInit, OnChanges {

  displayedColumns: string[] = ['segment_id', 'iteration_id'];

  selectedRows: { iteration_id: number, segment_id: number }[] = [];

  iterationIds: number[] = [];

  @Input() rows: { iteration_id: number, segment_id: number }[] = [];

  @ViewChild('table') table: MatTable<Iteration>;

  @Output() rowClicked = new EventEmitter<{ iteration_id: number, segment_id: number }>();

  constructor(private service: RouteChildrenEmitterService) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {

    const currentRows: {iteration_id: number, segment_id: number}[] = changes.rows.currentValue;

    const iterationIds = currentRows.map(row => row.iteration_id);
    this.iterationIds = Array.from(new Set(iterationIds));
    this.selectedRows = [];
  }

  /**
   * 
   */
  onRowClicked(row: { iteration_id: number, segment_id: number}) {
    this.handleRowClick(row);
    this.service.emit(this.selectedRows);
  }

  getRowClass(row: { iteration_id: number, segment_id: number }) {

    let rowIndex = this.selectedRows.indexOf(row);
    if (rowIndex == -1) {
      return '';
    }

    let iterationIdIndex = this.iterationIds.indexOf(row.iteration_id);

    if (iterationIdIndex == -1) {
      return '';
    }

    return `selected-${iterationIdIndex}`;
  }
  
  private handleRowClick(row: { iteration_id: number, segment_id: number }) {
    
    let element = this.selectedRows.find(r => 
      r.iteration_id === row.iteration_id && 
      r.segment_id === row.segment_id);
    
    console.log('cade po', element, this.selectedRows, row);
    if (element) {
      let index = this.selectedRows.indexOf(element);
      this.selectedRows.splice(index, 1);
      return;
    }

    this.selectedRows.push(row);
    console.log('adicionou', this.selectedRows);
  }
}
